export default __webpack_public_path__ + "static/media/stations.21566dbe.png";